import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { colors } from 'design-system';

const makeFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputRow: {
      padding: '8px 0',
    },
    hasInvoiceLabel: {
      color: colors.silver,
      fontWeight: 'normal',
    },
    hasInvoiceContainer: {
      padding: '10px !important',
    },
    customerInputRow: {
      padding: '8px 0',
    },
    inputModel: {
      [theme.breakpoints.up('md')]: {
        paddingRight: theme.spacing(4),
      },
    },
    inputYear: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(4),
      },
    },
    formCardContent: {
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
      },
    },
    buttonContainer: {
      marginTop: theme.spacing(3),
      display: 'inline-block',
      width: 300,
      [theme.breakpoints.down('sm')]: {
        width: 240,
      },
    },
    linkStyle: {
      color: `${colors.bright_turquoise}`,
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '18px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'none',
      '&:hover, &:focus': {
        backgroundColor: `${colors.white}`,
      },
    },
    invoiceMark: {
      cursor: 'pointer',
    },
  }),
);
export default makeFormStyles;
